/**
 * AdContextCard — o anúncio que trouxe o lead, acima da bolha da mensagem.
 *
 * O lead de anúncio click-to-WhatsApp (ou de anúncio no Instagram/Messenger)
 * chega só com a frase padrão da Meta ("Olá! Posso ter mais informações sobre
 * isso?"). O backend grava o anúncio na mensagem (`ad_context`, ou `adContext`
 * no QR) com a flag INBOX_AD_CARD_ENABLED; aqui é só o VISUAL do operador.
 *
 * COMPARTILHADO pelos 4 inboxes (core): um arquivo, três ChatWindows.
 * A imagem vive no CDN da Meta e pode expirar: o onError esconde a miniatura
 * sem quebrar o card.
 */
import React, { useState } from 'react';
import { Megaphone, ExternalLink } from 'lucide-react';

/** Contexto do anúncio da mensagem, nos dois formatos (doc cru e shape do QR). */
export const adContextOf = (msg) => {
  const ad = msg?.ad_context || msg?.adContext;
  if (!ad || typeof ad !== 'object') return null;
  if (!(ad.titulo || ad.texto || ad.url || ad.midia)) return null;
  return ad;
};

const AdContextCard = ({ ad, colors }) => {
  const [broken, setBroken] = useState(false);
  if (!ad) return null;
  const label = ad.tipo === 'post' ? 'Veio de uma publicação' : 'Veio de um anúncio';

  return (
    <div style={{
      borderLeft: `3px solid ${colors?.accentPrimary || '#25D366'}`,
      paddingLeft: 8, marginBottom: 6,
      display: 'flex', flexDirection: 'column', gap: 6,
      maxWidth: 320,
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 6,
        fontSize: 12, fontWeight: 600, opacity: 0.9,
      }}>
        <Megaphone size={13} style={{ flexShrink: 0 }} />
        <span>{label}</span>
      </div>

      <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
        {ad.midia && !broken && (
          <img
            src={ad.midia}
            alt=""
            style={{
              width: 64, height: 64, objectFit: 'cover',
              borderRadius: 6, flexShrink: 0, display: 'block',
            }}
            onError={() => setBroken(true)}
          />
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
          {ad.titulo && (
            <span style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.3 }}>
              {ad.titulo}
            </span>
          )}
          {ad.texto && (
            <span style={{ fontSize: 12, opacity: 0.8, lineHeight: 1.35 }}>
              {ad.texto}
            </span>
          )}
          {ad.url && (
            <a
              href={ad.url}
              target="_blank"
              rel="noreferrer"
              style={{
                fontSize: 12, display: 'inline-flex', alignItems: 'center', gap: 4,
                color: colors?.accentPrimary, textDecoration: 'none', marginTop: 2,
              }}
            >
              <ExternalLink size={12} style={{ flexShrink: 0 }} />
              Ver anúncio
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdContextCard;
